import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeProblem } from '../components/home/HomeProblem';
import { HomeOfferings } from '../components/home/HomeOfferings';
import { HomeJudgmentFlow } from '../components/home/HomeJudgmentFlow';
import { HomeEcosystem } from '../components/home/HomeEcosystem';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-2254" data-mp="2s1o48hx6joy2" />
      <HomeProblem data-id="element-2255" data-mp="2s27b93laksxb" />
      <HomeOfferings data-id="element-2256" data-mp="2s2qqgcjk537n" />
      <HomeJudgmentFlow data-id="element-2257" data-mp="2rzbbd9pvvu68" />
      <HomeEcosystem data-id="element-2258" data-mp="36qbv4aw2zaho" />
      <HomeAudiences data-id="element-2259" data-mp="36qk8s5012jtx" />
      <HomeCTA data-id="element-2260" data-mp="36r3qbklrn67f" />
    </>;
}